var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoveColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F43756"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0144 7.61602C12.2256 7.40402 12.4144 7.21122 12.6072 7.02322C13.8704 5.79442 15.6472 5.50322 17.0344 6.30322C18.4544 7.12082 19.1704 8.93841 18.744 10.6128C18.488 11.62 17.9824 12.4976 17.3576 13.3096C15.872 15.2416 13.9744 16.72 12.008 18.152C10.3064 16.9192 8.66399 15.6408 7.27439 14.0672C6.57198 13.272 5.94878 12.4224 5.53838 11.4368C5.05838 10.2928 4.95278 9.13602 5.50079 7.98002C6.55278 5.76242 9.09119 5.17042 11.0256 6.70002C11.3688 6.97042 11.6712 7.29522 12.0144 7.61602Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveColored);
export default __webpack_public_path__ + "static/media/love-colored.b8102019a15228cdf6890f423973a1b6.svg";
export { ForwardRef as ReactComponent };